/* eslint-disable no-empty-pattern */
import { createReducer, on } from '@ngrx/store';

import * as fromActions from '../actions/auth.actions';

export interface AuthState {
  refreshToken: string | null;
  bearerToken: string | null;
  resetStatus: boolean | null;
  verificationStatus: string | null;
  error: {
    errorMessage: string | null;
    resetErrorMessage: string | null;
    loginAttemptsData: any | null;
  };
  loaded: boolean;
}

export const initialState: AuthState = {
  refreshToken: null,
  bearerToken: null,
  resetStatus: false,
  verificationStatus: '',
  error: {
    errorMessage: null,
    resetErrorMessage: null,
    loginAttemptsData: null,
  },
  loaded: false,
};

export const reducer = createReducer(
  initialState,
  on(
    fromActions.AuthLoginSuccess,
    fromActions.SetAuthCredentials,
    fromActions.ResetPasswordSuccess,
    (state: AuthState, { payload }) => {
      const error = {
        errorMessage: null,
        resetErrorMessage: null,
        loginAttemptsData: null,
      };

      return { ...state, ...payload, error };
    },
  ),
  on(fromActions.ResetPasswordFail, (state: AuthState, { errorMessage }) => {
    const error = {
      errorMessage: null,
      resetErrorMessage: errorMessage || '',
      loginAttemptsData: null,
    };
    return { ...state, error, resetStatus: true };
  }),
  on(fromActions.SetDefaultResetStatus, fromActions.ClearResetStatus, (state: AuthState, {}) => (
    { ...state, resetStatus: false }
  )),
  on(fromActions.AuthLoginFail, (state: AuthState, { payload }) => {
    const error = {
      errorMessage: 'Incorrect email and/or password.',
      resetErrorMessage: null,
      loginAttemptsData: payload?.error,
    };

    return { ...state, error };
  }),
  on(fromActions.VerifyUser, (state: AuthState, { payload }) => {
    const error = {
      errorMessage: null,
      resetErrorMessage: null,
      loginAttemptsData: null,
    };
    return { ...state, ...payload, error };
  }),
  on(fromActions.VerifyUserSuccess, (state: AuthState, { payload }) => {
    const error = {
      errorMessage: null,
      resetErrorMessage: null,
      loginAttemptsData: null,
    };
    return {
      ...state,
      error,
      verificationStatus: payload.verificationStatus,
    };
  }),
  on(fromActions.VerifyUserFail, (state: AuthState, { payload }) => {
    const error = {
      errorMessage: payload,
      resetErrorMessage: null,
      loginAttemptsData: null,
    };
    return { ...state, error, verificationStatus: '' };
  }),
  on(fromActions.RestorePassword, (state: AuthState, {}) => ({ ...state, loaded: false })),
  on(fromActions.RestorePasswordSuccess, (state: AuthState, {}) => {
    const error = {
      errorMessage: null,
      resetErrorMessage: null,
      loginAttemptsData: null,
    };
    return { ...state, error, loaded: true };
  }),
  on(fromActions.AuthLogout, (state: AuthState, {}) => ({ ...state, loaded: false })),
  on(fromActions.ResetErrors, (state: AuthState, {}) => {
    const error = {
      errorMessage: null,
      resetErrorMessage: null,
      loginAttemptsData: null,
    };
    return { ...state, error };
  }),
  on(fromActions.ResetLoaded, (state: AuthState, {}) => ({ ...state, loaded: false })),
);

export const selectAuthRefreshToken = (state: AuthState) => state.refreshToken;
export const selectAuthAccessToken = (state: AuthState) => state.bearerToken;
export const selectResetStatus = (state: AuthState) => state.resetStatus;
export const selectVerifyStatus = (state: AuthState) => state.verificationStatus;
export const selectAuthError = (state: AuthState) => state.error;
export const selectLoaded = (state: AuthState) => state.loaded;
